(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-einstant/assets/javascripts/shared/components/slide-indicator.js') >= 0) return;  svs.modules.push('/modules/tickets-einstant/assets/javascripts/shared/components/slide-indicator.js');
"use strict";


const _React = React,
  useMemo = _React.useMemo;
const _svs$ui$ReactNavigati = svs.ui.ReactNavigationIndicator,
  NavigationIndicator = _svs$ui$ReactNavigati.NavigationIndicator,
  NavigationIndicatorDot = _svs$ui$ReactNavigati.NavigationIndicatorDot,
  NavigationIndicatorPrev = _svs$ui$ReactNavigati.NavigationIndicatorPrev,
  NavigationIndicatorNext = _svs$ui$ReactNavigati.NavigationIndicatorNext;
const SlideIndicator = _ref => {
  let totalCount = _ref.totalCount,
    activeSlide = _ref.activeSlide,
    setActiveSlide = _ref.setActiveSlide,
    isNextDisabled = _ref.isNextDisabled,
    nextSlide = _ref.nextSlide,
    isPrevDisabled = _ref.isPrevDisabled,
    prevSlide = _ref.prevSlide,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  const dotsArr = useMemo(() => Array.from({
    length: totalCount
  }, (_, index) => React.createElement(NavigationIndicatorDot, {
    "aria-current": activeSlide === index ? 'true' : undefined,
    "aria-label": "Sida ".concat(index + 1, " av ").concat(totalCount),
    className: "navigation-indicator-dot ".concat(activeSlide === index ? 'navigation-indicator-dotactive' : ''),
    isActive: activeSlide === index,
    key: index,
    onClick: () => setActiveSlide(index)
  })), [totalCount, activeSlide, setActiveSlide]);
  return React.createElement(NavigationIndicator, {
    className: className
  }, React.createElement(NavigationIndicatorPrev, {
    "aria-label": "F\xF6reg\xE5ende sida",
    disabled: isPrevDisabled,
    onClick: prevSlide
  }), dotsArr, React.createElement(NavigationIndicatorNext, {
    "aria-label": "N\xE4sta sida",
    disabled: isNextDisabled,
    onClick: nextSlide
  }));
};
setGlobal('svs.eInstant.shared.components.SlideIndicator', SlideIndicator);

 })(window);